import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { getAvailableTags } from 'lib/enums/GlobalManufacturerHarvestTags';

const AVAILABLE_TAGS = getAvailableTags();

function TagFilter({ selectedTags, onChange }) {
  const handleChange = options => {
    onChange(options || []);
  };

  return (
    <Form.Group className="mb-0">
      <Form.Label>Filter by Tags</Form.Label>
      <Select
        isMulti
        isClearable
        options={AVAILABLE_TAGS}
        value={selectedTags}
        onChange={handleChange}
        placeholder="Select tags to filter..."
        isSearchable
      />
    </Form.Group>
  );
}

TagFilter.propTypes = {
  selectedTags: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
};

TagFilter.defaultProps = {
  selectedTags: [],
};

export default TagFilter;
